export default __webpack_public_path__ + "static/media/N_wdt_c_cap_3.437a9f48.mp3";